<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            d="M9.79196 13.3186H9.77951C9.34751 13.3132 8.9804 13.0457 8.84351 12.6359L6.19996 4.70257L5.06307 7.86079C4.84085 8.4759 4.25329 8.88924 3.59996 8.88924H1.55729C1.18929 8.88924 0.890625 8.59057 0.890625 8.22257C0.890625 7.85457 1.18929 7.5559 1.55729 7.5559H3.59907C3.6924 7.5559 3.77685 7.49724 3.80796 7.40835L5.27107 3.34257C5.41685 2.93635 5.7644 2.65013 6.22218 2.68213C6.65418 2.68746 7.02129 2.95502 7.15818 3.36479L9.80262 11.2981L10.9395 8.1399C11.1617 7.52479 11.7493 7.11146 12.4026 7.11146H14.4444C14.8124 7.11146 15.1111 7.41013 15.1111 7.77813C15.1111 8.14613 14.8124 8.44479 14.4444 8.44479H12.4026C12.3093 8.44479 12.2248 8.50346 12.1937 8.59235L10.7306 12.6581C10.5857 13.0608 10.2177 13.3186 9.79107 13.3186H9.79196Z"
            fill="currentColor"
        />
    </svg>
</template>
